module.exports = __webpack_public_path__ + "img/menu3.f644c600.png";